














































































import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import ListViewItem from 'list-view/src/listviewitem';
import PartnerModel from '@views/a-model/partner-model';
import DefaultModel from '@views/a-model/default-model';
import ImagePreviewModel from 'crop-image/src/ImagePreviewModel';
import EnumPartnerType from '../../dataSource/api/RunPay/DataModels/Enums/EnumPartnerType';
import ControlValidatorGroupComponent from '../components/control-validator-group.vue';
import MainSliderItemResponse from '../../dataSource/api/RunPay/Admin/IServices/Models/MainSliderItem/MainSliderItemResponse';
import SaveMainSliderItemRequest from '../../dataSource/api/RunPay/Admin/IServices/Models/MainSliderItem/SaveMainSliderItemRequest';
import MainSliderItemTranslation from '../../dataSource/api/RunPay/Admin/IServices/Models/MainSliderItem/MainSliderItemTranslation';
import SaveMainSliderItemTranslate from '../../dataSource/api/RunPay/Admin/IServices/Models/MainSliderItem/SaveMainSliderItemTranslate';
import ImagePreviewSizeModel from 'crop-image/src/ImagePreviewSizeModel';
import ObjectFabric from '../components/objectFabric';
import CropImageRequest from '../../dataSource/api/RunPay/Admin/IServices/Models/Common/CropImageRequest';
// import appsettings from '../../../appsettings.json'

@Component({
  name: 'banners',
  components: {},
})
export default class BannersComponent extends Vue {
  innerItems: MainSliderItemResponse[] = [];
  
  langArr = ['en', 'ar', 'fr','ru'];
  defaultLang = 'fr';
  // langArr = [ 'ro', 'ru'];
  // defaultLang = 'ro';
  
  pageSize = 10;
  currentPage = 0;
  totalItems = 0;

  banners: Array<MainSliderItemResponse> = [];
  innerBanners: Array<MainSliderItemResponse> = [];
  currentPageId = 0;

  croped = false;
  innerImageCrope = '';
  maxSizeFileAvatar = 300000;
  // imgCrop:ImagePreviewModel
  imgCrop: ImagePreviewModel = ObjectFabric.create(ImagePreviewModel, {
    ImageUrl: '',
    Width: 0,
    Height: 0,
    Top: 0,
    Left: 0,
  });
  /*
   *modal window
   */
  modalWindowShow = false;
  addingBanner: SaveMainSliderItemRequest = new SaveMainSliderItemRequest();
  // fileList:Array<any>=[];
  file: string = null;
  modalWindowCrop = false;
  Foto = new ImagePreviewModel();

  pages = Array<ListViewItem<DefaultModel>>();

  innerImagePreviewSize: ImagePreviewSizeModel;

  isLoading = true;

  created() {
    const appsettings= require("../../../appsettings.json")
    const ProjectOptions = appsettings.ProjectOptions;
    this.langArr = ProjectOptions.langArr;
    this.defaultLang = ProjectOptions.defaultLang;   
  // defaultLang = 'ro';
  // const appsettings= require("/assets/appsettings.json")
    // console.log(appsettings)
    document.title = this.$route.meta.title;
    // this.getPages();
    this.getBanners({ Take: this.pageSize, Skip: this.currentPage });
    // this.changePageId(this.currentPageId);
  }

  updateCrop(val: { left: number; top: number; height: number; width: number }) {
    this.innerImagePreviewSize = ObjectFabric.create(ImagePreviewModel, {
      Width: val.width,
      Height: val.height,
      Top: val.top,
      Left: val.left,
    });
  }

  onClickOkCrop() {
    this.croped = true;

    this.imgCrop = ObjectFabric.create(ImagePreviewModel, {
      ImageUrl: this.innerImageCrope,
      Width: this.innerImagePreviewSize.Width,
      Height: this.innerImagePreviewSize.Height,
      Top: this.innerImagePreviewSize.Top,
      Left: this.innerImagePreviewSize.Left,
    });
  }

  isValid(): boolean {
    return (this.$refs.validator as ControlValidatorGroupComponent).isValid();
  }

  getPages() {
    this.pages.push(new ListViewItem(new DefaultModel(1, '10'), false, false));
    this.pages.push(new ListViewItem(new DefaultModel(1, '15'), false, false));
    this.pages.push(new ListViewItem(new DefaultModel(1, '25'), false, false));
    this.pages.push(new ListViewItem(new DefaultModel(1, '100'), false, false));
  }

  getBanners({ Skip, Take }: { Skip: number; Take: number }) {
    this.$api.MainSliderService.GetPaginatedListEvent.once((response) => {
      this.isLoading = false;
      if (!response.IsSuccess) {
        this.$notification.error(response.ErrorMessage.toString())
        return;
      }
      this.banners = [];
      this.totalItems = response.Value.Count;
      this.banners = response.Value.Items.map((item) => ({
        Id: item.Id,
        Url: item.Id.toString() +'_'+this.getImgDefault(item.Translations) +'.jpg',
        Translations: item.Translations,
        Title: this.getTitleDefault(item.Translations),
      }));
    });

    this.isLoading = true;
    this.$api.MainSliderService.GetPaginatedList({
      Skip: this.currentPage,
      Take: this.pageSize,
    });
  }

  getImgDefault(val: Array<MainSliderItemTranslation>) {
    const currentLang = this.$locale.currentLang;
    // if (val.length==1) return (val[0].Name||"").toString();
    return ((val.find((el) => el.LangCode == currentLang) || val[0]).LangCode).toString();
  }
  getTitleDefault(val: Array<MainSliderItemTranslation>) {
    const currentLang = this.$locale.currentLang;
    // if (val.length==1) return (val[0].Name||"").toString();
    return ((val.find((el) => el.LangCode == currentLang) || val[0]).Title || '').toString();
  }

  getImage(id: number): string {
    return '/files/partners/' + id + '.jpg';
  }

  onDownload() {
    (this.$refs.fileInput as any).click();
  }

  async onDeleteBanner(id: number) {
    var res = await this.$dialog.confirm(this.$locale.getTranslate('Dialog_reallyDelete')).then((res: boolean) => {
      if (res) {
        this.$api.MainSliderService.DeleteEvent.once((response) => {
          if (!response.IsSuccess) {
            return;
          }
          this.getBanners({ Take: this.pageSize, Skip: this.currentPage });
        });
        this.$api.MainSliderService.Delete(id);
      }
      if (res == false) {
      }
    });
  }

  onAddingBanner() {
    this.imgCrop = ObjectFabric.create(ImagePreviewModel, {
      ImageUrl: '',
      Width: 0,
      Height: 0,
      Top: 0,
      Left: 0,
    });
    this.addingBanner = new SaveMainSliderItemRequest();
    this.addingBanner.Translations = Array<SaveMainSliderItemTranslate>();
    this.langArr.forEach((i) => {
      this.addingBanner.Translations.push({ LangCode: i, Title: '', Image: this.imgCrop });
    });
    // this.addingBanner.Translations.push({ LangCode: this.$locale.getLangCodeById(0), Title: '', Image: this.imgCrop });
    // this.addingBanner.Translations.push({ LangCode: this.$locale.getLangCodeById(4), Title: '', Image: this.imgCrop});
    this.modalWindowShow = true;
    this.file = null;
  }

  onClickAddFile() {
    (this.$refs.fileInput as any).click();
  }

  imageBase64Ok(res: string) {
    // debugger
    this.innerImageCrope = res;
    this.imgCrop = new ImagePreviewModel();
    this.croped = false;
    // this.imgCrop.ImageUrl=res;
    // this.innerСropImagePreview=res
    this.modalWindowCrop = true;
  }

  onChangedImage() {
    var file = (this.$refs.fileInput as any).files[0];
    this.getBase64(file).then(
      (res: string) => {
        this.imageBase64Ok(res);
      },
      (rej: string) => alert(rej)
    );
    (this.$refs.fileInput as any).value = null;
  }

  getBase64(file: any): Promise<string> {
    return new Promise((resolve, reject) => {
      var reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = function () {
        resolve(reader.result.toString());
      };
      reader.onerror = function (error) {
        console.error('Error: ', error);
        reject(error);
      };
    });
  }

  closeModalWindow() {
    this.innerImageCrope = '';
    this.modalWindowShow = false;
  }

  onDeleteImage() {
    this.innerImageCrope = '';
  }

  onCreateBanner() {
    if (!this.isValid()) {
      return;
    }
   
    this.isLoading = true;

    this.$api.MainSliderService.SaveEvent.once((response) => {
      if (!response.IsSuccess) {
        return;
      }

      this.closeModalWindow();
      this.getBanners({ Take: this.pageSize, Skip: this.currentPage });
    });

    this.$api.MainSliderService.Save({
      // Title: this.addingBanner.Title.toString(),
      Translations: this.addingBanner.Translations,
      Url: this.addingBanner.Url
    });
    this.modalWindowShow = false;
  }

  onPaginationChanged(request: { Page: number; CountOnPage: number }) {
    this.getBanners({
      Skip: (request.Page - 1) * request.CountOnPage,
      Take: request.CountOnPage,
    });
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./scripts/views/pages/page-banners.vue